__webpack_require__.p = "/moozik/";